import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';
import CampaignModel from '../model/CampaignModel.js';

/**
 * @method apiGetCampaign
 * @method apiGetCampaignDetail
 * @method apiGetCampaignCustom
 * @method apiRedeemCampaign
 */
export default {
    /**
     * @param {String} strBzbsToken
     * @param {Object} objListConfig (Require) CampaignListConfigModel - /core/Campaign/model/CampaignConfigModel.js
     * @param {Object} objListFilterConfig (Optional) CampaignListFilterConfigModel - /core/Campaign/model/CampaignConfigModel.js
     */
    apiGetCampaign: function (strBzbsToken, objListConfig, objListFilterConfig) {
        var params = objListConfig.getParams();
        if (objListFilterConfig != null) {
            var filter = objListFilterConfig.getParams();
            params = {...params , ...filter};
        }

        var strUrl = Vue.bzbsConfig.bzbsUrl+ "/campaign";
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(strUrl, strBzbsToken, params).then((response) => {
                var arrCampaign = [];
                for (var i of response.data) {
                    var objCampaign = new CampaignModel(i);
                    arrCampaign.push(objCampaign);
                }

                resolve(arrCampaign);
            }).catch((error) => {
                reject(error);
            });
        });
    },

    /**
     * @param {String} strBzbsToken (Require)
     * @param {Object} objDetailConfig (Require) CampaignConfigModel - /core/Campaign/model/CampaignConfigModel.js
     */
    apiGetCampaignDetail: function (strBzbsToken, objDetailConfig) {
        var params = objDetailConfig.getParams();
        var url = Vue.bzbsConfig.bzbsUrl + "/campaign/" + objDetailConfig.strId;
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(url, strBzbsToken, params).then((data) => {
                var campaign = new CampaignModel(data.data);
                resolve(campaign);
            }).catch((error) => {
                reject(error);
            });
        });
    },

   apiGetCampaignCustom: function (strBzbsToken, objDetailConfig) {
        var params = objDetailConfig.getParams();
        var url = Vue.bzbsConfig.bzbsUrl + "/campaign/detail?campaignId=" + objDetailConfig.strId;
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(url, strBzbsToken, params).then((data) => {
                var campaign = new CampaignModel(data.data);
                resolve(campaign);
            }).catch((error) => {
                reject(error);
            });
        });
    },

    /**
     * @param {String} strBzbsToken
     * @param {String|Number} campaignId
     * @param {Object} objRedeemConfig RedeemConfigModel - /core/Campaign/model/CampaignModel.js
     * @param {Object} objRedeemProfileInfoConfig RedeemShippingAdressModel - /core/Campaign/model/CampaignModel.js
     * @param {Object} objRedeemInfoConfig RedeemInfoConfigModel - /core/Campaign/model/CampaignModel.js
     * @param {Object} objRedeemLocationConfig RedeemLocationConfigModel - /core/Campaign/model/CampaignModel.js
     * @param {Object} objRedeemOtherConfig RedeemOtherConfigModel - /core/Campaign/model/CampaignModel.js
     */
    apiRedeemCampaign: function (strBzbsToken, campaignId, objRedeemConfig, objRedeemProfileInfoConfig, objRedeemInfoConfig, objRedeemLocationConfig, objRedeemOtherConfig, redeemQuantity) {
        var params = {};

        if (!campaignId) {
            // failCallback("-9400", "-9400", "Bad parameter::Missing campaign model configuration.", "template_send", objRedeemConfig);
            return null;
        }

        if (objRedeemProfileInfoConfig) {
            if (objRedeemProfileInfoConfig.firstName)
                params.firstname = objRedeemProfileInfoConfig.firstName;

            if (objRedeemProfileInfoConfig.lastName)
                params.lastname = objRedeemProfileInfoConfig.lastName;

            if (objRedeemProfileInfoConfig.address)
                params.address = objRedeemProfileInfoConfig.address;

            if (objRedeemProfileInfoConfig.contactNumber)
                params.contact_number = objRedeemProfileInfoConfig.contactNumber;

            if (objRedeemProfileInfoConfig.email)
                params.email = objRedeemProfileInfoConfig.email;

            if (objRedeemProfileInfoConfig.shippingFirstName)
                params.shippingFirstName = objRedeemProfileInfoConfig.shippingFirstName;

            if (objRedeemProfileInfoConfig.shippingLastName)
                params.shippingLastName = objRedeemProfileInfoConfig.shippingLastName;

            if (objRedeemProfileInfoConfig.zipcode)
                params.zipcode = objRedeemProfileInfoConfig.zipcode;

            if (objRedeemProfileInfoConfig.addressKey)
                params.address_key = objRedeemProfileInfoConfig.addressKey;
        }

        if (objRedeemInfoConfig) {
            if (objRedeemInfoConfig.info1) params.info1 = objRedeemInfoConfig.info1;
            if (objRedeemInfoConfig.info2) params.info2 = objRedeemInfoConfig.info2;
            if (objRedeemInfoConfig.info3) params.info3 = objRedeemInfoConfig.info3;
            if (objRedeemInfoConfig.info4) params.info4 = objRedeemInfoConfig.info4;
            if (objRedeemInfoConfig.info5) params.info5 = objRedeemInfoConfig.info5;
        }

        if (objRedeemLocationConfig) {
            if (objRedeemLocationConfig.locationId) params.location_id = objRedeemLocationConfig.locationId;
            if (objRedeemLocationConfig.center) params.center = objRedeemLocationConfig.center;
            if (objRedeemLocationConfig.latitude) params.latitude = objRedeemLocationConfig.latitude;
            if (objRedeemLocationConfig.longitude) params.longitude = objRedeemLocationConfig.longitude;
        }

        if (objRedeemOtherConfig) {
            if (objRedeemOtherConfig.isCache == false) params.cache = objRedeemOtherConfig.isCache;
            if (objRedeemOtherConfig.redeemBy) params.redeem_by = objRedeemOtherConfig.redeemBy;
            if (objRedeemOtherConfig.tranId) params.tranId = objRedeemOtherConfig.tranId;
            if (objRedeemOtherConfig.reservationjson) params.reservationjson = objRedeemOtherConfig.reservationjson;
            if (objRedeemOtherConfig.promoCode) params.promocode = objRedeemOtherConfig.promoCode;
            if (objRedeemOtherConfig.spBaht) params.sp_baht = objRedeemOtherConfig.spBaht;
            if (objRedeemOtherConfig.spPoints) params.sp_points = objRedeemOtherConfig.spPoints;
            if (objRedeemOtherConfig.giftTo) params.giftto = objRedeemOtherConfig.giftTo;
        }

        var strUrl = Vue.bzbsConfig.bzbsUrl + "/campaign/" + campaignId + "/redeem";

        if (!isNaN(redeemQuantity) && redeemQuantity > 1) {
            params.quantity = redeemQuantity;
            strUrl = Vue.bzbsConfig.bzbsUrl + "/campaign/" + campaignId + "/bulkredeem";
        }

        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsPost(strUrl, strBzbsToken, params).then((res) => {
                var data = res.data;

                resolve(data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
}
